import http from './api'

export interface EmailPreferences {
  footballEmailsEnabled: boolean
  formula1EmailsEnabled?: boolean
}

class EmailPreferencesService {
  async get(): Promise<EmailPreferences> {
    const res = await http.get<EmailPreferences>('/email-preferences/me')
    return res.data
  }

  async update(patch: Partial<EmailPreferences>): Promise<EmailPreferences> {
    const res = await http.patch<EmailPreferences>('/email-preferences/me', patch)
    return res.data
  }
}

const emailPreferencesService = new EmailPreferencesService()
export default emailPreferencesService
